// src/shared/roles.js - who counts as STORE staff (v133.50). Used by the Worker and the apps.
//
// Matt, 6 Oct 2026: an Area Manager (promoted from store manager) was still listed among the people who have
// not completed their induction. Every store-level list counted all active staff, whatever their role, so a
// promoted person stayed on their old store's induction board, induction email, review and training counts.
// Area Managers and Head Office are not store staff: they are left out of store-level lists and counts. Their
// staff record and its history stay exactly as they are; only the counting changes.
//
// staff.role is free text ("Store Manager", "store_manager", "Area Manager", "area_manager", "Head Office"...),
// so it is normalised the way promotion-dossier.js's normRole does. Anything not recognised is store staff:
// the safe direction, since leaving a real store person off a list would hide them.

function norm(role) {
  return String(role == null ? '' : role).trim().toLowerCase().replace(/[\s-]+/g, '_');
}

export function isAreaLevel(role) {
  const r = norm(role);
  return r === 'area_manager' || r === 'am' || r === 'head_office' || r === 'ho';
}

export function isStoreLevel(role) {
  return !isAreaLevel(role);
}

// For a list of staff rows ({ role, ... }): only the store staff
export function storeStaffOnly(rows) {
  return (Array.isArray(rows) ? rows : []).filter((s) => s && isStoreLevel(s.role));
}
